"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_responsive_1 = require("react-responsive");
const Desktop = (props) => React.createElement(react_responsive_1.default, Object.assign({}, props, { minDeviceWidth: 1280 }));
const Tablet = (props) => React.createElement(react_responsive_1.default, Object.assign({}, props, { minDeviceWidth: 768, maxDeviceWidth: 1279 }));
const Mobile = (props) => React.createElement(react_responsive_1.default, Object.assign({}, props, { maxDeviceWidth: 767 }));
const responsiveContainer = (wrappedComponentProps = {}) => (Component) => {
    const Fragment = React.Fragment;
    return (React.createElement(Fragment, null,
        React.createElement(Desktop, null,
            React.createElement(Component, Object.assign({}, wrappedComponentProps, { device: "Desktop" }))),
        React.createElement(Tablet, null,
            React.createElement(Component, Object.assign({}, wrappedComponentProps, { device: "Tablet" }))),
        React.createElement(Mobile, null,
            React.createElement(Component, Object.assign({}, wrappedComponentProps, { device: "Mobile" })))));
};
exports.default = responsiveContainer;
